module.exports = __webpack_public_path__ + "img/tripti.8ccf154a.jpg";